import React, { useRef, useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { GetCareerPathCourses } from 'services/core';
import ExploreContentCardNew from 'components/common/ExploreContentCardNew/ExploreContentCardNew';

import classes from './CareerPathWrapper.module.scss';
//swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';
SwiperCore.use([Autoplay]);

import useWindowSize from 'hooks/use-windowSize';


const CareerPathWrapper = ({ career_path, toast }) => {
    const componentRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0 }
        );

        if (componentRef.current) {
            observer.observe(componentRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const { data, isLoading } = useQuery(
        ['career-path-courses', career_path.id],
        () => GetCareerPathCourses(career_path.id),
        { enabled: isVisible }
    );
    
    const { tabletDevice, mobileDevice } = useWindowSize();
    
    return (
        <div ref={componentRef}>
            {!isLoading && data && data.data.length > 0 && (
                <Swiper
                    slidesPerView={mobileDevice ? 1.1 : tabletDevice ? 2.1 : 3.1}
                    spaceBetween={20}
                    className={classes['mySwiper']}>
                    {data.data.map((content) => (
                        <SwiperSlide style={{ height: 'auto' }} className={classes['hover-scale']} key={content.id}>
                            <div key={content.id} className={classes['card-wrapper']}>
                                <ExploreContentCardNew
                                    content={content}
                                    toast={toast}
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            )}
        </div>
    );
};

export default CareerPathWrapper;